import React from "react";
import "./App.css";
import { TooltipProvider } from "./components/ui/tooltip";
import { Toaster } from "./components/ui/sonner";
import { CadProvider, useCad } from "./context/CadContext";
import { Header } from "./components/Header";
import { LeftPanel } from "./components/LeftPanel";
import { RightPanel } from "./components/RightPanel";
import { Canvas2D } from "./components/Canvas2D";
import { Viewport3D } from "./components/Viewport3D";

function Stage() {
  const { layout } = useCad();
  return (
    <div className="flex-1 min-h-0 relative">
      {layout === "split" && (
        <div className="h-full w-full grid grid-cols-2 divide-x divide-slate-800">
          <Canvas2D />
          <Viewport3D />
        </div>
      )}
      {layout === "2d" && <Canvas2D />}
      {layout === "3d" && <Viewport3D />}
    </div>
  );
}

function Workspace() {
  return (
    <div className="h-screen w-screen flex flex-col bg-[#070B12] text-slate-200 overflow-hidden grain">
      <Header />
      <div className="flex-1 min-h-0 flex">
        <LeftPanel />
        <Stage />
        <RightPanel />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <CadProvider>
      <TooltipProvider delayDuration={200}>
        <Workspace />
        <Toaster position="bottom-center" theme="dark" richColors />
      </TooltipProvider>
    </CadProvider>
  );
}
